/**
 * Rune Variant Options for VariantSelector
 *
 * Provides type-safe option array for rune variant selection.
 * Labels are capitalized for display (e.g., "air" → "Air").
 */

import {
  RUNE_VARIANTS,
  type RuneVariant,
} from "../../managers/scene/RuneManager.js";
import type { VariantOption } from "../components/VariantSelector.js";

/**
 * Capitalize first letter of a string
 */
function capitalize(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

/**
 * Rune variant options for VariantSelector component.
 * Uses capitalized labels for display.
 */
export const RUNE_VARIANT_OPTIONS: readonly VariantOption<RuneVariant>[] =
  RUNE_VARIANTS.map((v) => ({
    label: capitalize(v),
    value: v,
  }));
